import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { RangeControls, WordsChart, bucketize, useStatsRange } from "@/components/studio/WordsChart";
import { api } from "@/lib/api";
import { fmtNum } from "@/lib/studio";

export const WritingStats = () => {
  const r = useStatsRange();
  const { data } = useQuery({ queryKey: ["writing-stats", r.params], queryFn: () => api.get("/writing/stats", { params: r.params }).then((x) => x.data) });
  if (!data) return null;
  const { rows, gran } = bucketize(data.hours, r.start, r.end, r.gran);
  const period = data.hours.reduce((a, h) => a + h.words, 0);
  return (
    <div className="space-y-6" data-testid="writing-stats">
      <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div><div className="lf-label">All your stories · net words per {gran}</div><div className="mt-1 font-display text-3xl text-[#F3EBDD]" data-testid="writing-stats-period">{fmtNum(period)} <span className="text-sm text-[#A8A090]">words this period</span></div></div>
          <RangeControls r={r} effective={gran} />
        </div>
        <WordsChart rows={rows} />
      </section>
      <section className="rounded-md border border-[#2D3442] bg-[#0F131A] p-5">
        <div className="lf-label">By story</div>
        <table className="mt-3 w-full text-sm">
          <thead><tr className="text-left text-xs text-[#A8A090]"><th className="py-2 font-normal">Story</th><th className="font-normal">This period</th><th className="font-normal">Total words</th></tr></thead>
          <tbody>{data.stories.map((s) => (
            <tr key={s.id} className="border-t border-[#2D3442] text-[#F3EBDD]" data-testid={`writing-stats-story-${s.id}`}>
              <td className="py-2"><Link to={`/u/${s.universe_id}/studio/${s.id}`} className="hover:text-[#F59E0B]">{s.title}</Link></td>
              <td>{fmtNum(s.period_words)}</td><td>{fmtNum(s.total_words)}</td>
            </tr>
          ))}</tbody>
        </table>
      </section>
    </div>
  );
};
